<template lang="pug">
  .layout-view(:class="offset")
    controls-panel(
      @update="refresh")
    storage-tabs
    stock-panel(
      @update-stock-data="refresh")
    fodder-table(
      v-if="!isMobile"
      ref="table")
    fodder-table-mobile(
      v-else
      ref="tableMobile")
</template>

<script>
import adaptationMixin from '@/mixins/adaptation.mixin.js'

import ControlsPanel from './ControlsPanel'
import StorageTabs from '../common/StorageTabs'
import StockPanel from '../common/StockPanel'
import FodderTable from './table/FodderTable'
import FodderTableMobile from './table/FodderTableMobile'

export default {
  name: 'Fooder',

  mixins: [adaptationMixin],

  components: {
    ControlsPanel,
    StorageTabs,
    FodderTable,
    FodderTableMobile,
    StockPanel
  },

  computed: {
    offset () {
      return {
        'layout-view--offset-top': false
      }
    }
  },

  methods: {
    refresh (stockId, currentPage = 1) {
      // reloads table data if a new item added or updated
      if (this.$refs.table) {
        this.$refs.table.params.stock = stockId
        this.$refs.table.params.page = currentPage
        this.$refs.table.loadData()
      }
      if (this.$refs.tableMobile) {
        this.$refs.tableMobile.params.stock = stockId
        this.$refs.tableMobile.params.page = currentPage
        this.$refs.tableMobile.loadData()
      }
    }
  }
}
</script>
